import { ToastContainerConfig } from './utils/toastUtils';
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";

function App() {
  return (
    <>
      <ToastContainerConfig />
      <Router>
        <AppRoutes />
      </Router>
    </>
  );
}

export default App;
